
import React from "react";
import {
  Box, InputAdornment, Pagination, Paper, Stack,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TextField, Typography
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { IconButton } from "@mui/material";

export default function TableEmpresas({
  results, search, setSearch,
  page, rowsPerPage, totalPages,
  handleChangePage, onEdit, onDelete, onStatusChange
}) {

  const noData = () => (
    <Box
      sx={{
        width: "100%",
        height: 70,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <ManageSearchIcon sx={{ color: "#737791" }} />
      <Typography
        variant="body1"
        color="#737791"
      >
        Sin datos por mostrar
      </Typography>
    </Box>
  );

  return (
    <>
      <Paper sx={{ width: "100%", padding: 3 }}>
        <Box sx={{ padding: 1 }}>
          <TextField
            id="search"
            label="Buscar por empresa, RFC, etc..."
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            variant="standard"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            fullWidth
          />
        </Box>
        {results && results.length
          ? <TableContainer
            className="table-content"
            components={{
              Container: props => <Paper {...props} elevation={0} />
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Empresa</TableCell>
                  <TableCell>RFC</TableCell>
                  <TableCell>Servicios</TableCell>
                  <TableCell>Estatus</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? results.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                  : results
                ).map((row, i) => {
                  return (
                    <TableRow
                      key={i}
                      sx={{ "& td, & th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">{row.name}</TableCell>
                      <TableCell>{row.rfc}</TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1} alignItems="center">
                          {row.servicios && row.servicios.length > 0 ? (
                            <>
                              {row.servicios.slice(0, 2).map((servicio, idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    backgroundColor: '#7286D3',
                                    color: 'white',
                                    padding: '4px 12px',
                                    borderRadius: '8px',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                                  }}
                                >
                                  {servicio}
                                </Box>
                              ))}
                              {row.servicios.length > 2 && (
                                <Box
                                  sx={{
                                    backgroundColor: '#7286D3',
                                    color: 'white',
                                    padding: '4px 8px',
                                    borderRadius: '8px',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    minWidth: '30px',
                                    textAlign: 'center'
                                  }}
                                >
                                  +{row.servicios.length - 2}
                                </Box>
                              )}
                            </>
                          ) : (
                            <Typography variant="body2" color="#737791" sx={{ fontStyle: 'italic' }}>
                              Sin servicios
                            </Typography>
                          )}
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{ cursor: 'pointer', userSelect: 'none' }}
                          onClick={() => onStatusChange && onStatusChange(row)}
                        >
                          {row.status ? (
                            <>
                              <CheckCircleIcon color="success" fontSize="small" />
                              <Typography variant="body2">Activa</Typography>
                            </>
                          ) : (
                            <>
                              <CancelIcon color="error" fontSize="small" />
                              <Typography variant="body2">Inactiva</Typography>
                            </>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          <IconButton
                            onClick={() => onEdit && onEdit(row)}
                            size="small"
                            color="primary"
                            aria-label="editar"
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            onClick={() => onDelete && onDelete(row)}
                            size="small"
                            color="error"
                            aria-label="eliminar"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  )
                }
                )}
              </TableBody>
            </Table>
          </TableContainer>
          : noData()
        }
      </Paper>
      {results.length
        ? <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Stack className="pagination" spacing={2} mt={3}>
            <Pagination
              sx={{ width: "100%" }}
              color="primary"
              shape="rounded"
              count={totalPages}
              onChange={(event, value) => handleChangePage(value)}
              page={page}
              size="large"
            />
          </Stack>
        </Box>
        : <></>
      }
    </>
  );
}
